<template>
  <div>
    <p class="error">{{ error }}</p>

    <!-- <p class="decode-result">Last result: <b>{{ result }}</b></p> -->
    <!-- <qrcode-stream @decode="onDecode" @init="onInit" /> -->
    <div id="qr-code-full-region"></div>

    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-button class="cancel_button" size="small" v-on:click="onCancel" >Cancel</ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>

  </div>
</template>

<script>
// import { QrcodeStream } from '../../node_modules/vue3-qrcode-reader'
// import { StreamBarcodeReader } from "../../node_modules/vue-barcode-reader";
import {Html5QrcodeScanner, Html5QrcodeSupportedFormats} from "html5-qrcode"
import { IonGrid, IonRow, IonCol, IonButton, modalController } from '@ionic/vue';


export default {
  components: { IonGrid, IonRow, IonCol, IonButton, /* QrcodeStream, */ /*StreamBarcodeReader*/ },

  data () {
    return {
      result: '',
      error: '',
      modalController: modalController
    }
  },

  methods: {
    onCancel(){
      this.modalController.dismiss('cancelled');
    },

    onScanSuccess (decodedText, decodedResult) {
        console.log(decodedResult);
        this.result = decodedText
        this.modalController.dismiss(decodedText);
    }

  },

  mounted () {
    const formatsToSupport = [
      Html5QrcodeSupportedFormats.QR_CODE,
      Html5QrcodeSupportedFormats.CODE_128,
    ];
    const config = {
      fps: 30,
      qrbox: 220,
      facingMode: "environment",
      formatsToSupport: formatsToSupport
    };
    const html5QrcodeScanner = new Html5QrcodeScanner('qr-code-full-region', config);
    html5QrcodeScanner.render(this.onScanSuccess);
  }

}
</script>

<style scoped>
  .error {
    font-weight: bold;
    color: red;
  }

  .cancel_button {
    float:right;
  }
</style>
